export default __webpack_public_path__ + "static/Thecouscousmealthatfeedsgenerosity-26df3824c3f1ee822af583ead3dac157.jpg";